import axios from "axios";
import qs from "qs";
const initialState = {
	user: {
		
	},
	newUser: {
		kolkinid: "",
		email: "",
		password: "",
		type: "user"
	}
};

export const state = { ...initialState };

export const actions = {
	async checkSession (context) {
		return axios.get("/api/session").then(function(response){
			context.commit("setUser", response.data);
		}).catch(function(){})
	},

	async signout(context) {
		return axios.get("/api/signout").then(function(response) {
			context.commit("clearUser");
		});
	},

	async signup(context, newUser){
        return axios.post("/api/user", newUser);
    },

	async checkUser(context) {
		return axios.get("/api/user").then(function(response){
			context.commit("setUser", response.data);
		})
	},

	resetNewUser(context){
        context.commit('setNewUser',{
            kolkinid: "",
            email: "",
            password: "",
        });
    },
}

export const mutations = {
	setUser(state,data){
		state.user = data;
	},

	clearUser(state){
		state.user = {};
	},

    setNewUser(state,user){
        state.newUser = user;
    },
}

const getters = {
	user(state){
		return state.user;
	},
	newUser(state){
        return state.newUser;
    }
};

export default {
	state,
	actions,
	mutations,
	getters
  };
  